export const NAME_DEFAULT = 'count';



// WEBPACK FOOTER //
// ./src/components/parts/catalog/list/count/const.ts